/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

// overriding some default UJS stuff to work with Sweetalert
// https://github.com/t4t5/sweetalert

$.rails.allowAction = function(link) {
  if (!link.attr('data-confirm')) { return true; }
  $.rails.showConfirmDialog(link);
  return false; // always stops the action since code runs asynchronously
};

$.rails.confirmed = function(link) {
  link.removeAttr('data-confirm');
  return link.trigger('click.rails');
};

// Allows us to use a custom confirm() dialog and still
// have it act as if blocking the link's action until acted upon
$.rails.showConfirmDialog = function(link) {
  const message = link.attr('data-confirm');

  return swal({
    title: message,
    type: "warning",
    showCancelButton: true,
    closeOnConfirm: true,
    confirmButtonText: "Yes",
    confirmButtonColor: "#ec6c62"
    },
    () => $.rails.confirmed(link));
};


swal.setDefaults({
  animation: 'slide-from-top',
  confirmButtonColor: "#5eba32",
  showCancelButton: true
});
